// Vehicle battery MAC helpers — same rules as cms-api (src/util/vehicleMacSql.js) and
// cms-websocket, so the form validates exactly what the server accepts.

// Canonical form: hex digits only, upper-case. A vendor prefix ("VID:C408981A649F") is
// stripped first; a leading hex pair ("C4:08:...") is part of the MAC, not a prefix.
export const canonicalMac = (value) => {
  let text = String(value ?? "").trim();
  const prefixed = text.match(/^([A-Za-z][A-Za-z0-9_-]*)\s*:\s*(.+)$/);
  if (prefixed && !/^[0-9a-fA-F]{2}$/.test(prefixed[1])) {
    text = prefixed[2];
  }
  return text.replace(/[^0-9a-fA-F]/g, "").toUpperCase();
};

// Exactly 12 hex digits once separators/prefix are removed.
export const isValidMac = (value) => /^[0-9A-F]{12}$/.test(canonicalMac(value));

// "9CF6DD925BC3" (or any accepted input) -> "9C:F6:DD:92:5B:C3"; "" for empty.
export const formatMac = (value) => {
  const mac = canonicalMac(value);
  if (!mac) return "";
  return mac.length === 12 ? mac.match(/.{2}/g).join(":") : String(value).trim();
};
